import { z } from 'zod';
import { objKeys } from './utility';
// highTODO are we doing ULIDs, KSUID, or neither?
export const dateSchema = z.preprocess((arg) => {
    if (typeof arg === 'string' || arg instanceof Date)
        return new Date(arg);
}, z.date());
const base64UrlId = z.string().regex(/^[a-zA-Z0-9_-]{22}$/);
const base64urlHash = z.string().regex(/^[a-zA-Z0-9_-]{43}$/);
export const remoteNoteId = base64UrlId;
export const remoteTemplateId = base64UrlId;
export const templateId = base64UrlId;
export const remoteTemplateNoteId = base64UrlId;
export const commentId = base64UrlId;
export const noteId = base64UrlId;
export const mediaId = base64UrlId;
export const remoteMediaId = base64urlHash;
const fieldValues = z
    .record(z.string().min(1), z.string())
    .refine((x) => objKeys(x).length > 0);
const noteUneditable = {
    id: true,
    templateId: true,
    created: true,
    edited: true,
    nook: true,
    status: true,
};
export const nookIdRegex = /^[a-z][a-z0-9]{2,21}$/;
export const nookId = z
    .string()
    .regex(nookIdRegex);
const status = z.union([
    z.literal('awaitingMedia'),
    z.literal('draft'),
    z.literal('active'),
    z.literal('archived'),
]);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const proposalStatus = z.union([
    z.literal('awaitingMedia'),
    z.literal('draft'),
    z.literal('open'),
    z.literal('closed'),
    z.literal('merged'),
]);
export const remoteNote = z.object({
    id: remoteNoteId,
    nook: nookId,
    templateId: remoteTemplateId,
    created: dateSchema,
    edited: dateSchema,
    fieldValues,
    tags: z.array(z.string()),
    ankiId: z.number().positive().optional(),
    status,
});
export const createRemoteNote = remoteNote.omit(noteUneditable).extend({
    localId: z.string(),
    remoteTemplateIds: z.array(remoteTemplateId).min(1),
});
export const editRemoteNote = remoteNote.omit(noteUneditable).extend({
    localId: z.string(),
    remoteIds: z.map(remoteNoteId, remoteTemplateId).refine((x) => x.size > 0),
});
export const childTemplate = z.object({
    id: z.number().int(),
    name: z.string(),
    front: z.string(),
    back: z.string(),
    shortFront: z.string().optional(),
    shortBack: z.string().optional(),
});
const standard = z.object({
    tag: z.literal('standard'),
    templates: z.array(childTemplate).min(1),
});
const cloze = z.object({
    tag: z.literal('cloze'),
    template: childTemplate,
});
export const templateType = z.discriminatedUnion('tag', [standard, cloze]);
export const remoteTemplate = z.object({
    id: remoteTemplateId,
    nook: nookId,
    created: dateSchema,
    edited: dateSchema,
    name: z.string(),
    templateType,
    fields: z.array(z.string()),
    css: z.string(),
    ankiId: z.number().positive().optional(),
    status,
});
const templateUneditable = {
    id: true,
    nook: true,
    created: true,
    edited: true,
    status: true,
};
export const createRemoteTemplate = remoteTemplate
    .omit(templateUneditable)
    .extend({
    localId: templateId,
    nooks: z.array(nookId),
});
export const editRemoteTemplate = remoteTemplate
    .omit(templateUneditable)
    .extend({
    remoteIds: z.array(remoteTemplateId).min(1),
    localId: templateId,
});
export const commentText = z.string().min(1).max(1000);
